
import React, { useEffect } from 'react';
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken,isSupported } from 'firebase/messaging';
import useSendRegisterPushNotif from '../shared-hooks/useSendRegisterPushNotif';


const Firebase= ()=>{
  const firebaseConfig = {
    apiKey: "AIzaSyAD8aVhUPHxrK_AsrJjaz6uqRlPlavaaqM",
    authDomain: "shahrzad-802eb.firebaseapp.com",
    projectId: "shahrzad-802eb",
    storageBucket: "shahrzad-802eb.appspot.com",
    messagingSenderId: "495371308195",
    appId: "1:495371308195:web:efa691a0673f40dcd7c316",
    measurementId: "G-J8PNW4HT30"
  };
  
  const app = initializeApp(firebaseConfig);
  let messaging=null
  // const {requestNotification}=useSendRegisterPushNotif()

// useEffect(() => {
//       isSupported().then(()=>{
//         messaging=getMessaging(app)
//         requestNotification()
//       })
// }, [])


  return (null)
}

export default React.memo(Firebase)